import { supabase } from '../supabaseClient';
import { VEHICLE_TYPES } from '../constants';

const normalizePlate = (plate) => String(plate || '').toUpperCase().trim();

const PLACEHOLDER_PLATES = new Set(['SIN-PLACA', 'SINPLACA', 'SIN PLACA', 'S/P', 'SP', 'N/A', 'NA', 'PENDIENTE', 'TBD']);

export const isRealPlate = (plate) => {
    const clean = normalizePlate(plate);
    if (!clean) return false;
    if (PLACEHOLDER_PLATES.has(clean)) return false;
    return /[A-Z0-9]/.test(clean);
};

export const findVehicleByPlate = async (driverUid, plate) => {
    const cleanPlate = normalizePlate(plate);
    if (!driverUid || !cleanPlate) return null;

    const { data, error } = await supabase
        .from('vehicles')
        .select('*')
        .eq('driver_uid', driverUid)
        .eq('plate', cleanPlate)
        .limit(1);

    if (error) {
        console.warn('Error buscando vehículo por placa:', error.message);
        return null;
    }

    if (Array.isArray(data)) return data[0] || null;
    return data || null;
};

/**
 * Materializa el vehiculo de respaldo (id: null) del conductor.
 * Usa el RPC canonico save_driver_vehicle: valida que el conductor sea el
 * dueno, normaliza la placa, marca como principal si es su unico vehiculo y
 * sincroniza public.drivers con public.vehicles.
 */
export const ensureRealVehicle = async (vehicle) => {
    if (!vehicle) return { ok: false, reason: 'NO_VEHICLE' };
    if (vehicle.id) return { ok: true, vehicle, created: false, reused: false };

    const cleanPlate = normalizePlate(vehicle.plate);
    if (!isRealPlate(cleanPlate)) return { ok: false, reason: 'NO_PLATE' };

    const driverUid = vehicle.driver_uid;
    if (!driverUid) return { ok: false, reason: 'NO_DRIVER' };

    const existing = await findVehicleByPlate(driverUid, cleanPlate);
    if (existing) return { ok: true, vehicle: existing, created: false, reused: true };

    const parsedYear = vehicle.year && !Number.isNaN(parseInt(vehicle.year, 10))
        ? parseInt(vehicle.year, 10)
        : null;

    const { data, error } = await supabase.rpc('save_driver_vehicle', {
        p_driver_uid: driverUid,
        p_vehicle_type: vehicle.vehicle_type || VEHICLE_TYPES.MOTO,
        p_plate: cleanPlate,
        p_brand: vehicle.brand || null,
        p_model: vehicle.model || null,
        p_year: parsedYear,
        p_color: vehicle.color || null,
        p_is_default: false
    });

    const createdVehicle = data?.vehicle;
    if (error || !data?.success || !createdVehicle?.id) {
        console.warn('No se pudo materializar el vehículo:', error?.message);
        return { ok: false, reason: 'INSERT_FAILED', error };
    }

    return { ok: true, vehicle: createdVehicle, created: true, reused: false };
};
